import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import {
  PaymentStep,
  useStepContext,
} from '~/app/providers/paymentStepProvider';

import { type Certificate } from '../../../../../PayPage.scheme';
import { CertificateCard } from '../../../../CertificateCard/CertificateCard';

import {
  CardImage,
  GridContainer,
  Root,
  SingleCardWrapper,
} from './CardsList.ui';

export const CardList = ({ certificates }: { certificates: Certificate[] }) => {
  const { setValue } = useFormContext();
  const { goToStep } = useStepContext();

  const handleClick = (certificate: Certificate) => {
    setValue('certificate', certificate, { shouldValidate: true });

    if (certificate.type === 'single') {
      setValue('product', certificate.products?.[0], { shouldValidate: true });
    }

    if (certificate?.brand?.slug === 'steam') {
      goToStep(PaymentStep.STEAM);
    } else {
      goToStep(PaymentStep.SELECT_PRODUCT);
    }
  };

  const { singleCards, listCards } = useMemo(
    () => ({
      singleCards: certificates.filter(({ type }) => type === 'single'),
      listCards: certificates.filter(({ type }) => type === 'list'),
    }),
    [certificates],
  );

  return (
    <Root>
      {singleCards.map((certificate) => (
        <SingleCardWrapper key={certificate?.brand?.slug}>
          <CertificateCard
            certificate={certificate}
            onClick={handleClick}
            classNames={{ image: CardImage }}
          />
        </SingleCardWrapper>
      ))}
      <GridContainer>
        {listCards.map((certificate) => (
          <CertificateCard
            key={certificate?.brand?.slug}
            certificate={certificate}
            onClick={handleClick}
          />
        ))}
      </GridContainer>
    </Root>
  );
};
